import { memo } from 'react'
import styled from 'styled-components'
import { useSubscriptionPlans } from 'querys/subscriptions'
import { Typography } from 'common/typography'
import { SecondaryButton } from 'common/button'
import { useCountryCode } from 'querys/payment'
import DiscountTimer from 'common/banner/discount-timer'

const FullSubscriptionPaymentStyled = styled.div`
  .proyectos {
    color: var(--turquoise);
  }
  .card-title-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  .msi {
    margin: 8px 0;
    text-align: center;
  }
`

function FullSubscriptionPayment() {
  const { data: { countryCode } } = useCountryCode()
  const query = useSubscriptionPlans()
  const { data: plans } = query

  if (!plans) return null

  const isMexican = countryCode === 'MX' && plans?.year?.price?.currency_code === 'MXN'
  const isAnotherCountry = countryCode !== 'MX' && plans?.year?.price?.currency_code === 'USD'
  const isCorrectCountry = isMexican || isAnotherCountry
  if (!isCorrectCountry) return null

  const {
    price: { amount, currency_code }, discount, original_price,
  } = plans.year

  return (
    <FullSubscriptionPaymentStyled>
      <div className="card-title-container">
        <Typography className="card-title" font="headline6" color="var(--baseNeutral)" align="center">
          Acceso ilimitado al completarlo con tu suscripción anual
        </Typography>
      </div>
      <div className="pricing-status">
        <div className="price-container">
          <p className="price" data-cy="subscription-price">
            $
            {amount}
            {' '}
            {currency_code}
          </p>
          {discount?.status === 'VALID' && (
            <p className="original-price" data-cy="discount-price">
              $
              {original_price?.amount}
              {' '}
              {currency_code}
            </p>
          )}
        </div>
        <DiscountTimer discount={discount} alignSmall="start" align="center" color="var(--turquoise)" dataCy="video-card-timer" />
        {countryCode === 'MX' ? (
          <Typography font="p2Regular" className="msi">
            <b>Paga a 6 Meses sin intereses </b>
            <a href="/terminos#msi" target="_blank" rel="noopener noreferrer"> ** </a>
          </Typography>
        ) : null}
      </div>
      <SecondaryButton id="full-subscription-btn" href="/comprar/anual" responsive fullWidth>
        Suscribirme
      </SecondaryButton>
      <a href="#comprar" id="full-subscription-options" className="options">Ver opciones de pago</a>
    </FullSubscriptionPaymentStyled>
  )
}

export default memo(FullSubscriptionPayment)
